<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" lg="6" class="d-flex align-center">
            <div>
              <h1 class="title font-weight-light mb-lg-1">
                <v-icon class="mb-1" left>mdi-format-list-bulleted</v-icon>
                {{ $t("ORDERS.ORDERLIST.TITLE") }}
              </h1>
              <div class="pr-lg-15 mb-1"></div>
              <p class="text-caption font-weight-light mb-0">
                {{ $t("ORDERS.ORDERLIST.SUBTITLE") }}
              </p>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="d-flex align-end">
            <v-row class="mx-0">
              <v-col cols="12" lg="3" class="px-0 px-lg-2">
                <v-select
                  solo
                  dense
                  item-text="name"
                  item-value="name"
                  class="font-weight-light"
                  :label="$t('ORDERS.SELECTBOX.SEARCHALL')"
                  clearable
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" lg="9" class="px-0">
                <v-text-field
                  solo
                  :hint="$t('ORDERS.SELECTBOX.HINT')"
                  dense
                  :label="$t('ORDERS.SELECTBOX.LABEL')"
                  prepend-inner-icon="mdi-magnify"
                  class="urun-ara-text-field font-weight-light"
                  clearable
                >
                  <template v-slot:append>
                    <v-btn depressed icon class="urun-ara-btn">
                      <v-icon color="black">mdi-chevron-right</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="3" class="d-flex justify-center">
        <v-card elevation="0" color="white" class="rounded-xl">
          <v-card-text class="py-2 pl-4 pr-3">
            <div class="d-flex align-center">
              <v-icon size="1.5rem" left>mdi-calendar-range</v-icon>
              <div class="text-body-1 mr-3">{{ current.dates.length ? dateRangeText : "Tarih Aralığı Seçin" }}</div>
              <div v-show="current.dates.length === 2">
                <v-btn
                  small
                  rounded
                  elevation="0"
                  color="red lighten-3"
                  dark
                  class="text-capitalize"
                  @click="current.dates = []"
                >
                  <v-icon size="1rem" class="mr-1">mdi-close-circle-outline</v-icon>
                  Temizle
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9" class="d-flex align-center">
        <div :key="i" v-for="(i) in 7" class="mr-2">
          <v-btn small class="text-capitalize" depressed rounded color="grey lighten-2">
            {{ $dayjs().day(i).format("dddd") }}
          </v-btn>
        </div>
        <v-spacer />
        <div class="font-weight-bold mr-7">
          <v-btn
            rounded color="#333"
            dark small
            class="text-capitalize px-8"
            elevation="0"
            @click="cancelAndRefundModal.model = true"
          >
            <v-icon size="1rem" left style="top: -2px">mdi-cash-refund</v-icon>
            <v-badge
              v-if="cancelAndRefundOnHoldCount"
              color="red"
              class="pr-2"
              :content="cancelAndRefundOnHoldCount"
            >
              İptal & İade Talepleri
            </v-badge>
            <span v-else>
              İptal & İade Talepleri
            </span>
          </v-btn>
        </div>
        <div class="font-weight-bold">
          {{ $dayjs().format("YYYY") }}
        </div>
      </v-col>
      <v-col cols="12" lg="3">
        <v-card class="d-flex justify-center elevation-0 mb-3" color="transparent">
          <v-date-picker
            v-model="current.dates"
            range
          ></v-date-picker>
        </v-card>
        <v-card class="elevation-0 mb-3" color="transparent">
          <v-card-title class="flex-column">
            <div class="text-body-1 text-center font-weight-bold">
              <v-icon>mdi-filter-menu-outline</v-icon>
              Zamana Göre Filtele
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-column px-lg-10">
              <v-btn
                :key="key"
                v-for="(filter, key) in filtersInfo.ages"
                rounded
                depressed
                small
                class="text-capitalize font-weight-regular mb-1"
                :style="{ height: '30px' }"
                :color="!isDateFilter(filter) ? 'grey lighten-2' : 'primary'"
                @click="current.date = filter"
              >
                {{ filter.name }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="elevation-0" color="transparent">
          <v-card-title class="flex-column">
            <div class="text-body-1 text-center font-weight-bold">
              <v-icon>mdi-filter-menu-outline</v-icon>
              Sipariş Durumu
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-column px-lg-10">
              <v-btn
                rounded
                depressed
                small
                class="text-capitalize font-weight-medium mb-2"
                :style="{ height: '30px' }"
                color="primary"
                @click="filterOrderStatus(null)"
              >
                <v-icon
                  class="order-status--pin"
                  color="white"
                  v-show="isStatusFilter(null)"
                >
                  mdi-pin
                </v-icon>
                <span class="text--white">Tümü</span>
              </v-btn>
              <v-btn
                :key="key"
                v-for="(orderStatus, key) in orderStatuses"
                rounded
                depressed
                small
                class="text-capitalize font-weight-medium mb-2"
                :style="{ height: '30px' }"
                :color="orderStatusColors[orderStatus]"
                @click="filterOrderStatus(orderStatus)"
              >
                <v-icon
                  class="order-status--pin"
                  :color="orderStatusColorsText[orderStatus]"
                  v-show="isStatusFilter(orderStatus)"
                >
                  mdi-pin
                </v-icon>
                <span :style="{ color: orderStatusColorsText[orderStatus] }">{{ orderStatusNames[key] }}</span>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9">
        <v-data-table
          ref="dataTable"
          v-model="selectionSiparisler"
          :items="siparisler"
          :headers="table.headers"
          :no-data-text="table.noDataText"
          :loading-text="table.loadingText"
          calculate-widths
          hide-default-footer
          class="mb-3"
          @page-count="tableParams.pageCount = $event"
          :loading="siparisListesiLoading"
          :server-items-length="siparisSayisi"
        >
          <template v-slot:[`item.orderkod`]="{ item: { orderkod } }">
            <span class="text-caption">{{ orderkod }}</span>
          </template>
          <template v-slot:[`item.userinfo`]="{ item: { userinfo } }">
            <strong>{{ userinfo.name }}</strong>
          </template>
          <template v-slot:[`item.orderproducts`]="{ item: { orderproducts } }">
            {{ orderproducts.length }} adet ürün
          </template>
          <template v-slot:[`item.orderstatus`]="{ item: { orderstatus }, item }">
            <div class="d-flex align-center">
              <siparis-status-chip :key="orderstatus" :value="orderstatus" class="mr-2" />
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-tooltip :menu-listen="on" bottom color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        icon
                        :style="{ color: orderStatusColors[orderstatus] }"
                        @click="showChangeStatus(item)"
                      >
                        <v-icon size="1rem">mdi-arrow-u-left-bottom</v-icon>
                      </v-btn>
                    </template>
                    <span class="text-caption">Sipariş Durumunu Değiştir</span>
                  </v-tooltip>
                </template>
              </v-menu>
            </div>
            <!--            <v-chip color="yellow" size="small" class="text-caption" v-if="orderstatus">-->
            <!--              {{ $t("ORDERS.LIST.STATUS_W_FOR_APPRV") }}-->
            <!--            </v-chip>-->
          </template>
          <template v-slot:[`item.orderamount`]="{ item: { orderamount } }">
            <div class="d-flex text-caption">
              <strong>{{ formatFiyat(orderamount) }}</strong>
              <v-icon small color="primary" class="ml-1">mdi-currency-try</v-icon>
            </div>
          </template>
          <template v-slot:[`item.orderdate`]="{ item: { orderdate } }">
            <span class="text-caption font-weight-bold">{{ $dayjs(orderdate).format("ddd HH:ss - MMM DD") }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item: { orderid } }">
            <v-btn small depressed rounded color="grey lighten-2" class="text-capitalize font-weight-light mr-1"
                   @click="showOrderDetail(orderid)">
              <v-icon size="1rem" color="#333" class="mr-1">mdi-card-multiple</v-icon>
              Sipariş Detayı
            </v-btn>
            <v-btn small depressed rounded color="grey lighten-2" class="text-capitalize font-weight-light"
                   @click="showOrderShipping(orderid)">
              <v-icon size="1rem" color="#333" class="mr-1">mdi-truck-cargo-container</v-icon>
              Kargo Detayı
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="pagination.page"
          :length="tableParams.pageCount"
          circle
          @input="pageClick"
        ></v-pagination>
      </v-col>
    </v-row>
    <siparis-detay-modal v-model="orderDetailModal.model" :order-id="orderDetailModal.orderId" />
    <kargo-detay-modal v-model="shippingDetailModel.model" :order-id="shippingDetailModel.orderId" />
    <change-status-modal
      v-if="changeStatusModal.model"
      v-model="changeStatusModal.model"
      :status="changeStatusModal.status"
      :order-id="changeStatusModal.orderId"
      @update="updateOrderDetail(changeStatusModal.orderId, $event)"
    />
    <cancel-and-refund-modal v-model="cancelAndRefundModal.model" @updateCount="getCancelRefundOnHoldCount" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import {
  OrdersStatuses,
  OrderStatusColors,
  OrderStatusColorsText,
  OrderStatusNames
} from "@/core/constants/Orders.constants";
import { computed, ref } from "@vue/composition-api";
import SiparisStatusChip from "@/components/Modules/Siparisler/SiparisStatusChip.vue";
import KargoDetayModal from "@/components/Modules/Siparisler/KargoDetayModal.vue";
import SiparisDetayModal from "@/components/Modules/Siparisler/SiparisDetayModal.vue";
import ChangeStatusModal from "@/components/Modules/Siparisler/ChangeStatusModal.vue";
import CancelAndRefundModal from "@/components/Modules/Siparisler/CancelAndRefundModal.vue";
import SiparislerService from "@/services/SiparislerService";
import mainApp from "@/main";

const { $dayjs } = mainApp;

const convertToDate = (days = 0, manipulate = "subtract") => {
  const date = `${$dayjs()[manipulate](days, "day").format("YYYY-MM-DD")} 00:00:00`;

  return $dayjs(date).format("YYYY-MM-DD HH:mm:ss");
};

export default {
  name: "SiparisList",

  components: { CancelAndRefundModal, ChangeStatusModal, SiparisDetayModal, KargoDetayModal, SiparisStatusChip },

  data() {
    return {
      selectionSiparisler: []
    };
  },

  computed: {
    ...mapState({
      siparisListesi: state => state.Siparisler.SiparisList.siparisListesi,
      siparisListesiLoading: state => state.Siparisler.SiparisList.siparisListesiLoading
    }),
    siparisler() {
      return this.siparisListesi.list;
    },
    siparisSayisi() {
      return this.siparisListesi.count;
    },
    dateRangeText() {
      const [first, second] = this.current.dates;
      return [
        this.$dayjs(first).format("DD/MM/YYYY"),
        this.$dayjs(second).format("DD/MM/YYYY")
      ].join(" ~ ");
    }
  },

  setup() {
    const filtersInfo = computed(() => ({
      ages:
        [
          {
            name: "Tümü",
            value: 1
          },
          {
            name: "Son Aktiviteye Göre",
            value: 2
          },
          {
            name: "Bugün",
            value: {
              start: convertToDate(0),
              end: $dayjs().format("YYYY-MM-DD HH:mm:ss")
            }
          },
          {
            name: "Dün",
            value: {
              start: convertToDate(1),
              end: $dayjs().format("YYYY-MM-DD HH:mm:ss")
            }
          },
          {
            name: "Son 3 gün",
            value: {
              start: convertToDate(3),
              end: $dayjs().format("YYYY-MM-DD HH:mm:ss")
            }
          },
          {
            name: "Son 1 hafta",
            value: {
              start: convertToDate(7),
              end: $dayjs().format("YYYY-MM-DD HH:mm:ss")
            }
          },
          {
            name: "Son 1 ay",
            value: {
              start: convertToDate(31),
              end: $dayjs().format("YYYY-MM-DD HH:mm:ss")
            }
          }
        ]
    }));

    const current = ref({
      date: null,
      dates: [],
      status: null
    });

    current.value.date = filtersInfo.value.ages[1];

    const orderListParams = ref({
      start: 0,
      limit: 20,
      orderBy: "desc"
    });

    const table = {
      headers: [
        {
          text: "#Kod",
          align: "start",
          sortable: false,
          value: "orderkod"
        },
        { text: "Müşteri", value: "userinfo", sortable: false },
        { text: "Ürünler", value: "orderproducts", sortable: false },
        { text: "Durum", value: "orderstatus", sortable: false },
        // { text: "Ödeme Bilgisi", value: "orderstatus", sortable: false },
        { text: "Toplam Tutar", value: "orderamount", sortable: false },
        { text: "Sipariş Tarihi", value: "orderdate", sortable: false },
        { text: "İşlemler", value: "actions", sortable: false }
      ],
      noDataText: "Gösterilecek sipariş bulunmamaktadır",
      loadingText: "Sipariş Listesi Yükleniyor"
    };

    const tableParams = ref({
      page: 1,
      pageCount: 0,
      listStatus: true
    });

    const pagination = ref({
      page: 1,
      lastPage: 0
    });

    const orderDetailModal = ref({
      orderId: null,
      model: false
    });
    const shippingDetailModel = ref({
      orderId: null,
      model: false
    });
    const changeStatusModal = ref({
      status: 0,
      orderId: null,
      model: false
    });
    const cancelAndRefundModal = ref({
      model: false
    });

    const cancelAndRefundOnHoldCount = ref(null);

    return {
      filtersInfo,
      current,
      orderListParams,
      table,
      tableParams,
      pagination,
      orderStatuses: OrdersStatuses,
      orderStatusColors: OrderStatusColors,
      orderStatusColorsText: OrderStatusColorsText,
      orderStatusNames: OrderStatusNames,
      orderDetailModal,
      shippingDetailModel,
      changeStatusModal,
      cancelAndRefundModal,
      cancelAndRefundOnHoldCount
    };
  },

  methods: {
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.orderListParams.start = this.pagination.page * this.orderListParams.limit - this.orderListParams.limit;

        this.getSiparisList();
        // if (!this.yaziAraData.yaziAraText) {
        //   /**
        //    * Ürün listesini getir
        //    */
        //   this.getYaziListesi();
        // } else {
        //   /**
        //    * Arama var ise aramaya göre pagination getir
        //    */
        //
        //   /**
        //    * Ürünü aram sonucunu pagination'a göre getir
        //    */
        //   this.yaziAra();
        // }
      }
    },

    formatFiyat(fiyat) {
      var formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
      return formatter.format(fiyat).replace("₺", "");
    },

    isDateFilter(filter) {
      return Object.is(this.current.date, filter);
    },

    isStatusFilter(status) {
      return this.current.status === status;
    },

    showOrderDetail(orderId) {
      this.orderDetailModal.orderId = orderId;
      this.orderDetailModal.model = true;
    },

    showOrderShipping(orderId) {
      this.shippingDetailModel.orderId = orderId;
      this.shippingDetailModel.model = true;
    },

    showChangeStatus(order) {
      this.changeStatusModal.orderId = order.orderid;
      this.changeStatusModal.status = order.orderstatus;
      this.changeStatusModal.model = true;
    },

    getSiparisList() {
      const { start, limit, orderBy } = this.orderListParams;
      this.$store.dispatch("Siparisler/SiparisList/siparisListesi", {
        start,
        limit,
        orderBy,
        listBy: this.current
      }).then(({ data }) => {
        const { list, count } = data;
      });
    },

    updateOrderDetail(orderId, order) {
      const orderDetail = this.siparisListesi.list.find(o => o.orderid === orderId);
      const indexOf = this.siparisListesi.list.indexOf(orderDetail);

      const siparisList = this.siparisListesi.list;

      this.$set(siparisList[indexOf], "orderstatus", order.status);
    },

    getCancelRefundOnHoldCount() {
      SiparislerService.cancelAndRefundListOnHoldCount().then(({ status, data }) => {
        if (status === 200) {
          this.cancelAndRefundOnHoldCount = data;
        }
      });
    },

    filterOrderStatus(orderStatus) {
      this.current.status = orderStatus;
    },

    checkDatesFilter() {
      if (this.current.dates.length !== 2 && this.current.dates.length) {
        return false;
      }

      return true;
    }
  },

  created() {
    this.getSiparisList();
    this.getCancelRefundOnHoldCount();
  },

  watch: {
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    },

    current: {
      handler() {
        if (!this.checkDatesFilter()) return;

        this.getSiparisList();
      },
      deep: true
    }
  }
};
</script>

<style>
.urun-ara-btn {
  right: -5px;
}

.order-status--pin {
  position: absolute !important;
  margin-right: 0.3rem;
  transform: rotate(-15deg);
  left: 0;
  font-size: 1.4rem !important;
}
</style>
